import AOS from 'aos';

export function pageLoaded() {
	$('body').addClass('loaded');
	setTimeout(function() {
		AOS.init({
			duration: 800,
			offset: 20,
			once: true
		});
	},500);
}